import { useLocation } from "react-router-dom";

import {
  ApiReportReportStatusChoices,
  ApiReportReportTypeChoices,
  ApiReportTemplateExportFrameworkChoices,
} from "@api/graphql/types-and-hooks";
import { REVIEW_AND_SIGN_ROUTE } from "@components/ReportField/consts";
import { useReport, useReportOptional } from "@providers/ReportProvider";

export const useIsReportHandlebars = (): boolean => {
  const { report } = useReport();
  return (
    report.reportTemplate?.exportFramework === ApiReportTemplateExportFrameworkChoices.Handlebars &&
    !report.reportTemplate?.templateUrl
  );
};

export const useIsReportCompleted = (): boolean =>
  useReportOptional()?.report.reportStatus === ApiReportReportStatusChoices.Completed;

export const useIsReportBaseTemplate = (): boolean => {
  const { report } = useReport();
  return report.reportTemplate?.isBaseTemplate ?? false;
};

export const useIsReviewPage = (): boolean => useLocation().pathname.includes(REVIEW_AND_SIGN_ROUTE);

// The "clinical" surface (Reassessment, or a Diagnosis Evaluation viewed as a
// single page behind the db-single-page flag) as opposed to Assessment V2
// (InitialAssessment) or Evaluation's step viewer (DiagnosisEvaluation + step).
export const useIsClinicalSurface = (): boolean => {
  const { report, viewMode } = useReport();
  return (
    report.reportType === ApiReportReportTypeChoices.Reassessment ||
    (report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "single")
  );
};
